import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import * as permissionKind from '../../../../shared/permissions';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import { useCompany } from '../../../components/contexts/CompanyContextManager';
import NoItemResult from '../../../components/results/NoItemResult';
import hasPermissions from '../../../utilities/hasPermissions';
import { useUpdateUserGroupDrawer } from './UserGroupUpdateDrawer';

export type UserGroupSuperiorGroupEmptyListProps = { userGroup: UserGroupSpecsFragment };

const UserGroupSuperiorGroupEmptyList = ({ userGroup }: UserGroupSuperiorGroupEmptyListProps) => {
    const { t } = useTranslation(['userGroupDetails']);
    const addSuperiorUserGroupDrawer = useUpdateUserGroupDrawer(userGroup);
    const { permissions: accountPermissions } = useAccount();
    const company = useCompany(true);
    const hasPermission = company
        ? hasPermissions(company.permissions, [permissionKind.createUserGroup]) &&
          hasPermissions(accountPermissions, [permissionKind.createUserGroup])
        : hasPermissions(accountPermissions, [permissionKind.createUserGroup]);

    return (
        <NoItemResult
            extra={
                <>
                    {hasPermission && (
                        <Button onClick={addSuperiorUserGroupDrawer.open} type="primary">
                            {t('userGroupDetails:tabs.parentUserGroups.noData.action')}
                        </Button>
                    )}
                    {addSuperiorUserGroupDrawer.render()}
                </>
            }
            subTitle={t('userGroupDetails:tabs.parentUserGroups.noData.message')}
        />
    );
};

export default UserGroupSuperiorGroupEmptyList;
